module.exports = __webpack_public_path__ + "img/base-greeting.0478a90.png";